import type { VisitPickerAction } from './nodeLabels'

export type ActiveVisitPickerRef = {
  nodeId: string
  action: VisitPickerAction
}

/** Same node+action click should toggle the multi-visit picker closed, not reopen it. */
export function shouldToggleCloseVisitPicker(
  activePicker: ActiveVisitPickerRef | null,
  nodeId: string,
  action: VisitPickerAction
): boolean {
  return activePicker !== null && activePicker.nodeId === nodeId && activePicker.action === action
}
